import React from 'react';
export default function Placeholder(props) {
  if (props.allowPlaceholderText) {
    return /*#__PURE__*/React.createElement("span", {
      "data-placeholder": "".concat(props.text)
    }, props.text);
  }
  return /*#__PURE__*/React.createElement("span", null);
}